import { UserRole } from "@/types/user";

export const getIsRole = (role: UserRole, expectedRole: UserRole) =>
    role === expectedRole;

export const getIsAdminRole = (role?: UserRole) =>
    role === "admin" || role === "superAdmin";

export const getIsSuperAdminRole = (role?: UserRole) => role === "superAdmin";
